import { defineAction } from '~/prix'
import { z } from 'zod'
import materialInventoryCreateAction from './materialInventoryCreate.action.json' with { type: 'json' }
import { materialInventoryObject } from '../materialInventoryObject'

const materialInventoryCreateDefinition = defineAction({
  ...materialInventoryCreateAction,

  input: materialInventoryObject
    .pick({
      id: true,
      materialId: true,
      quantity: true,
      type: true,
    })
    .partial({ id: true }),
  output: z.object({ id: materialInventoryObject.shape.id }),
})

export default materialInventoryCreateDefinition
